import { render, staticRenderFns } from "./NewBaseFormInput.vue?vue&type=template&id=983414ac"
import script from "./NewBaseFormInput.vue?vue&type=script&lang=ts"
export * from "./NewBaseFormInput.vue?vue&type=script&lang=ts"
import style0 from "./NewBaseFormInput.vue?vue&type=style&index=0&id=983414ac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports